import { Injectable } from '@angular/core'
import { Subject, Subscription } from 'rxjs'
import { filter, map } from 'rxjs/operators'

export type EventName = 'login'

export class EventData<T> {
  name: EventName
  value: T

  constructor(name: EventName, value: T) {
    this.name = name
    this.value = value
  }
}

@Injectable({
  providedIn: 'root',
})
export class EventBusService<T> {
  // Generic type for consistency
  private subject$ = new Subject<EventData<T>>()

  constructor() {}

  emit(event: EventData<T>) {
    this.subject$.next(event)
  }

  on(eventName: string, action: () => void): Subscription {
    return this.subject$
      .pipe(
        filter((e: EventData<T>) => e.name === eventName),
        map((e: EventData<T>) => e.value), // Access value as a property
      )
      .subscribe(action)
  }
}
